import { clsx as e } from "clsx";
import { extendTailwindMerge as t } from "tailwind-merge";
// libs/ui-lib/src/lib/utils.ts
var n = t({ extend: { theme: { text: [
	"md",
	"xlg",
	"xxlg",
	"heading-sm",
	"heading-md",
	"heading-lg",
	"heading-xl",
	"code-sm",
	"code-md"
] } } });
function r(...t) {
	return n(e(t));
}
function i(e) {
	let t = e.trim();
	if (!t) return null;
	let [n = "", ...r] = t.split(":");
	if (!r.length) return null;
	let i = n.trim(), a = r.join(":").trim();
	return !i || !a ? null : {
		field: i,
		value: a
	};
}
export { r as cn, i as parseFieldValueInput };
